export default __webpack_public_path__ + "e9b01cce161b86f23ea701ec6e554e79.png";